class CacheLoader {
  constructor() {
    this.loadedFiles = [];
    this.products_cache = {};
    this.product_data_cache = {};
    this.inline_css = {};

    this.product = this.product.bind(this);
    this.productData = this.productData.bind(this);
    this.loadFiles = this.loadFiles.bind(this);

    if (window.pending_files && window.pending_files.length) {
      this.loadFiles(window.pending_files);
    }
  }

  loadFiles(fileArr) {
    [...fileArr].forEach(({ type, src }) => {
      if (type === "css") this.css(src);
      if (type === "js") this.js(src);
    });
  }

  fileAlreadyLoaded(src) {
    return this.loadedFiles.includes(src);
  }

  js(src) {
    if (this.fileAlreadyLoaded(src))
      return new Promise((resolve, reject) => resolve());

    return new Promise((resolve, reject) => {
      let $script = document.createElement("script");

      const type = src.indexOf("esm") === -1 ? "text/javascript" : "module";

      console.log("JS file", { src, type });

      $script.setAttribute("type", type);
      $script.setAttribute("src", src);
      $script.setAttribute("defer", "defer");

      $script.onload = () => {
        this.loadedFiles.push(src);
        resolve(true);
      };

      document.getElementsByTagName("head")[0].appendChild($script);
    });
  }

  inlineCss(name, css) {
    if (this.inline_css[name]) return;

    const $style = document.createElement("style");

    $style.type = "text/css";

    if ($style.styleSheet) {
      // This is required for IE8 and below.
      $style.styleSheet.cssText = css;
    } else {
      $style.appendChild(document.createTextNode(css));
    }

    document.getElementsByTagName("head")[0].appendChild($style);
  }

  css(src) {
    if (this.fileAlreadyLoaded(src)) return;

    let $stylesheet = document.createElement("link");

    $stylesheet.setAttribute("rel", "stylesheet");
    $stylesheet.setAttribute("type", "text/css");
    $stylesheet.setAttribute("href", src);

    this.loadedFiles.push(src);
    document.getElementsByTagName("head")[0].appendChild($stylesheet);
  }

  async product(handle) {
    if (this.products_cache[handle]) return this.products_cache[handle];

    let product = await fetch(`/products/${handle}.js`).then((res) =>
      res.json()
    );

    this.products_cache[handle] = product;

    return product;
  }

  async productData(handle) {
    if (this.product_data_cache[handle]) return this.product_data_cache[handle];

    let product = await fetch(`/products/${handle}?view=json`).then((res) =>
      res.json()
    );

    this.product_data_cache[handle] = product;

    return product;
  }
}

window.ThemeLoader = new CacheLoader();
